import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "9ee8fa50-e7ec-4b8e-985e-72717ed04317", content: "Phase shift: 0</br>Phase velocity: ∞", options: {} },
  { id: "851b79bd-e64c-40f5-99e9-6250cab11d14", content: "Phase shift: π/4</br>Phase velocity: 0 m/s", options: {} },
  { id: "0a6870c8-7bc5-481f-ac05-cc26fa8b377d", content: "Phase shift: π/2</br>Phase velocity: 343 m/s", options: {} },
  { id: "1a637cd1-033c-4806-96d4-4138c747c4fb", content: "Phase shift: 2π</br>Phase velocity: 396 m/s", options: {} },
];

export const task: Task = {
  id: "d66cea00-324f-49e9-b786-4bd691940f90",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["0a6870c8-7bc5-481f-ac05-cc26fa8b377d"],
};
